type CopyToClipboardFunction = (text: string) => Promise<void>

interface UseCopyToClipboardType {
	copyToClipboard: CopyToClipboardFunction
}

const useCopyToClipboard = (
	onSuccess: (text: string) => void
): UseCopyToClipboardType => {
	const copyToClipboard: CopyToClipboardFunction = async (text) => {
		try {
			// Try using the modern Clipboard API first
			await navigator.clipboard.writeText(text)
			onSuccess?.(text)
		} catch (err) {
			console.error(
				'Failed to copy using Clipboard API, falling back to execCommand',
				err
			)
			// Fallback to the older method
			const textArea = document.createElement('textarea')
			textArea.value = text

			textArea.style.top = '0'
			textArea.style.left = '0'
			textArea.style.position = 'fixed'
			textArea.style.opacity = '0'

			document.body.appendChild(textArea)
			textArea.focus()
			textArea.select()

			try {
				await document.execCommand('copy')
				onSuccess?.(text)
			} catch (err) {
				console.error('Fallback: Oops, unable to copy', err)
			}
			document.body.removeChild(textArea)
		}
	}

	return { copyToClipboard }
}

export default useCopyToClipboard
